module.exports = __webpack_public_path__ + "img/image.6f4f9fe2.svg";